import { z } from "zod";

import { inspectionSchema } from "~/modules/basecamp-run-inspector/schemas";
import { feedbackSchema } from "~/modules/basecamp-style-reviews/schemas";

export const userOutputTierSchema = z.enum(["Quick", "Standard", "Advanced", "Ultra"]);
export const userOutputStatusSchema = z.enum(["queued", "processing", "complete", "failed"]);

export const userOutputSearchSchema = z.object({
  styleId: z.string().optional().default(""),
  chosenTier: z
    .union([z.literal("any"), userOutputTierSchema, z.literal("none")])
    .optional()
    .default("any")
    .catch("any"),
  employees: z.enum(["exclude", "include"]).optional().default("exclude").catch("exclude"),
});

export const userOutputSchema = z.object({
  operationId: z.string(),
  editPlanId: z.string(),
  projectId: z.string().nullable(),
  engine: z.enum(["basecamp", "native_harness"]).optional().default("basecamp"),
  styleId: z.string().nullable(),
  styleName: z.string().nullable(),
  chosenTier: userOutputTierSchema.nullable(),
  modelId: z.string().nullable(),
  workflowId: z.string().nullable(),
  status: userOutputStatusSchema,
  videoAssetId: z.string().nullable(),
  videoUrl: z.string().nullable().optional(),
  renderError: z.string().nullable().optional(),
  projectProtoUri: z.string().nullable(),
  error: z.string().nullable(),
  latencySeconds: z.number().finite().nonnegative().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  feedback: feedbackSchema.nullable(),
  notes: z.array(feedbackSchema),
});

export const userOutputExportStatusSchema = z.object({
  exportTapped: z.boolean(),
  firstExportTapAt: z.string().nullable(),
  exported: z.boolean(),
});

export const userOutputExportStatusesResponseSchema = z.object({
  items: z.record(z.string(), userOutputExportStatusSchema.nullable()),
});

export const userOutputStylesSchema = z.array(z.object({ styleId: z.string(), name: z.string() }));

export const userOutputsResponseSchema = z.object({
  items: z.array(userOutputSchema),
  nextCursor: z.string().nullable(),
});

export const userOutputDetailSchema = z.object({
  output: userOutputSchema,
  prompt: z.string().nullable(),
  aspectRatio: z.string().nullable(),
  attachments: z.array(z.record(z.unknown())),
  sourceAssetIds: z.array(z.string()),
});

export const userOutputInspectionSchema = inspectionSchema.extend({ operationId: z.string() });

export type UserOutputSearch = z.output<typeof userOutputSearchSchema>;
export type UserOutput = z.infer<typeof userOutputSchema>;
export type UserOutputExportStatus = z.infer<typeof userOutputExportStatusSchema>;
